import { useState } from "react";

interface ColorPickerProps {
  value: string | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
}

const PRESET_COLORS = [
  "#ff6b6b", "#feca57", "#48dbfb", "#1dd1a1", "#5f27cd",
  "#ff9ff3", "#54a0ff", "#00d2d3", "#ff9f43", "#ee5a24",
  "#c8d6e5", "#8395a7", "#576574", "#222f3e", "#ffffff",
];

export default function ColorPicker({ value, onChange, placeholder = "#ff6b6b" }: ColorPickerProps) {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <div
          onClick={() => setShowPicker(!showPicker)}
          style={{
            width: 36, height: 36, borderRadius: 6, border: "1px solid var(--border)",
            background: value || "transparent", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          {!value && <span style={{ color: "var(--muted)", fontSize: 20 }}>+</span>}
        </div>
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value || null)}
          placeholder={placeholder}
          style={{ flex: 1, fontFamily: "monospace" }}
        />
      </div>

      {showPicker && (
        <div style={{
          position: "absolute", top: "100%", left: 0, zIndex: 100,
          marginTop: 8, padding: 12, borderRadius: 8,
          background: "var(--bg-elevated)", border: "1px solid var(--border)",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)", minWidth: 200,
        }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 8 }}>
            {PRESET_COLORS.map(c => (
              <div
                key={c}
                onClick={() => { onChange(c); setShowPicker(false); }}
                style={{
                  width: 32, height: 32, borderRadius: 4, cursor: "pointer",
                  background: c, border: c === "#ffffff" ? "1px solid var(--border)" : "none",
                }}
                title={c}
              />
            ))}
          </div>
          <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
            <input
              type="color"
              value={value || "#000000"}
              onChange={(e) => onChange(e.target.value)}
              style={{ width: 40, height: 32, padding: 0, border: "none", cursor: "pointer" }}
            />
            <button
              className="ghost"
              style={{ fontSize: 12, padding: "6px 12px" }}
              onClick={() => { onChange(null); setShowPicker(false); }}
            >
              Vymazat
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
